/**
 * React Query hook for getting organization statistics
 */

import { useQuery } from '@tanstack/react-query'
import { dataApiClient } from '../client'
import { QueryOptions, staticCacheConfig } from '../../../lib/utils'
import type { OrganizationRequest, OrganizationResponse } from '../'

/**
 * React Query hook for fetching organization statistics
 */
export function useOrganization(
  request: OrganizationRequest,
  options?: QueryOptions<OrganizationResponse, Error, OrganizationResponse>
) {
  return useQuery({
    queryKey: ['organization', JSON.stringify(request.filter_set)],
    queryFn: async (): Promise<OrganizationResponse> => {
      const response = await dataApiClient.POST('/organization', {
        body: request,
      })

      if (response.error) {
        throw new Error(`Organization request failed: ${response.error}`)
      }

      return response.data
    },
    ...staticCacheConfig,
    ...options,
  })
}
